import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 1rem 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-block-start: 4rem;
  ${Styles.desktop} {
    margin-block-start: 6.5rem;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 130px;
  svg {
    height: 130px;
  }
`;

export const HeadingText = styled.h1`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-size: 1.5rem;
  text-align: center;
  text-transform: ${Styles.textTransform.headlines};
  width: 100%;
`;

export const BodyText = styled.p`
  font-family: ${Styles.fontFamily.body};
  font-size: 1rem;
  text-align: center;
`;
